<template>
        <div class="edits setting theme-card">
            <div class="setting-h1">
                Verify Your Payment
            </div>
            <div class="setting-h2">
                You are seeing this option because you have a payment session that is currently open in our record. But sometimes a payment may have be completed and successful on our payments service provider's end but when navigated back to us, our system might fail to automatically verify the payment and restore your services. This clickable Verify Payment button is a self-service feature. It allows you to verify your payment and restore your services if our system fails to do so automatically. 
            </div>
           
        <form> 
         <div class="form-buttons">
                <button @click.prevent="verifyPaymentAsync" :disabled="loading" class="btn btn-default primary-btn" style="background-color:var(--page-header)!important;color:var(--enterprise-button)!important;">
                    {{ loading == true ? 'Verifying Payment...':'Verify Payment' }}
                </button>
            </div>
           
        </form>
        <SystemMessage style="font-size:1rem!important;" v-if="!loading && error" :message="message"/>
    
        
        </div>
</template>
<script>
import { canAccess as authCanAccess } from '@/services/authService';
import SystemMessage from '@/components/Utility/SystemMessage.vue';
import { VerifyPayment } from '@/services/billing/billingService';

export default {
    components:{
        SystemMessage
    },
    data(){
        return{
            loading: false,
            error: false,
            message:""
        }
    },
    methods:{
        canAccess(path){
            return authCanAccess(path);
        },
         async verifyPaymentAsync(){
        try{
            this.loading = true;
            this.error = false;
            let response = await VerifyPayment();
            if(!response.success){
                let err = new Error(response.message);
                err.reason = response.caption;
                throw err;
            }else{

                if(response.transactionInfo.status == 'pending'){
                    let err = new Error("There is payment session that hasn't been completed yet. But you can create a new one to override it by clicking the 'Pay' button.");
                    throw err;
                }else if(response.transactionInfo.status == 'failed'){
                     let err = new Error("It seems your payment session failed which indicates the transaction was not successful. But you can create a new one by clicking the 'Pay' button.");
                    throw err;
                }

                if(!this.canAccess('enterprise')){
                    this.$router.push("/");
                }else{
                    this.$router.push("/enterprise/home");
                }
            }
        }catch(e){
              this.loading = false;
              this.message = e.message || "Unable to verify your payment. Please try again later";
              this.error = true;
              setTimeout(() => {
                this.message = "";
                this.error = false;
              }, 5000);
        }
        },
        
    }
}
</script>
<style scoped>

.theme-card{
    background:var(--intro-background)!important;
    min-height:11rem;
}

.setting{
    margin-left:1.2rem;
    border-bottom:0px;
}


.setting-h1{
    color:var(--page-header);
    margin-bottom:0.8rem;
}

.edit-profile{
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    margin:4.5rem 0rem;
}

.edits{
    grid-column:2/3;
}

    .select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}

select{
    min-width:9rem;
}

@media (max-width:768px) {
    .edits{
    grid-column:1/4;
    margin:0rem 0.8rem;
}

.theme-card{
    margin-top:0.9rem;
}
}
</style>